// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as TicketsRequestMapper from "../../../ticket-dashboard/app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as DriverBasicInfoVMMapper from "../view-modal/vm-mapper/DriverBasicInfoVMMapper.bs.js";
import * as DriverLeadPageViewStore from "../view-modal/view-store/DriverLeadPageViewStore.bs.js";

function DriverLeadPageHeaderCmp$TicketButtonCmp(Props) {
  var label = Props.label;
  var callback = Props.callback;
  return React.createElement("div", {
              className: "ticket-button",
              onClick: (function (param) {
                  return Curry._1(callback, undefined);
                })
            }, label);
}

var TicketButtonCmp = {
  make: DriverLeadPageHeaderCmp$TicketButtonCmp
};

function DriverLeadPageHeaderCmp$HeaderDetailCmp(Props) {
  var label = Props.label;
  var value = Props.value;
  return React.createElement("div", {
              key: label,
              className: "info-wrapper"
            }, React.createElement("div", {
                  className: "label"
                }, label), React.createElement("div", {
                  className: "value " + DriverBasicInfoVMMapper.getHeaderValueClassname(label, value)
                }, value));
}

var HeaderDetailCmp = {
  make: DriverLeadPageHeaderCmp$HeaderDetailCmp
};

function DriverLeadPageHeaderCmp(Props) {
  var lead_id = Props.lead_id;
  var onboarding_status = Props.onboarding_status;
  var timestamp = Props.timestamp;
  var dashboard_flow = Props.dashboard_flow;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  return React.createElement("div", {
              className: "partner-header-container"
            }, React.createElement("div", {
                  className: "lead-info-container"
                }, React.createElement("div", {
                      className: "header-title"
                    }, DriverLeadPageViewStore.partner_lead_info_title), React.createElement("div", {
                      className: "lead-info-wrapper"
                    }, Belt_List.toArray(List.map((function (param) {
                                return React.createElement(DriverLeadPageHeaderCmp$HeaderDetailCmp, {
                                            label: param[0],
                                            value: param[1]
                                          });
                              }), DriverBasicInfoVMMapper.getHeaderDetails(lead_id, dashboard_flow, onboarding_status, timestamp))))), React.createElement("div", {
                  className: "ticket-controller"
                }, React.createElement(DriverLeadPageHeaderCmp$TicketButtonCmp, {
                      label: DriverLeadPageViewStore.raise_ticket_label,
                      callback: (function (param) {
                          return Curry._2(workspaceDispatch.addTab, {
                                      TAG: /* RaiseTicket */14,
                                      _0: undefined
                                    }, false);
                        })
                    }), React.createElement(DriverLeadPageHeaderCmp$TicketButtonCmp, {
                      label: DriverLeadPageViewStore.view_ticket_label,
                      callback: (function (param) {
                          return Curry._2(workspaceDispatch.addTab, {
                                      TAG: /* Tickets */42,
                                      _0: TicketsRequestMapper.DictEncoder.execute({
                                            crn: undefined,
                                            case_number: undefined,
                                            caller_number: undefined,
                                            msisdn: undefined,
                                            start_datetime: undefined,
                                            end_datetime: undefined,
                                            ticket_status: undefined,
                                            geo_region: undefined,
                                            raised_by: undefined
                                          })
                                    }, false);
                        })
                    })));
}

var make = DriverLeadPageHeaderCmp;

export {
  TicketButtonCmp ,
  HeaderDetailCmp ,
  make ,
  
}
/* react Not a pure module */
